import { Helper } from '../Helper';
export class AddEmptyModuleHelper extends Helper {
    emit(sb, node, optionsIn) {
        const options = sb.pushValueOptions(optionsIn);
        sb.emitHelper(node, options, sb.helpers.getModules);
        sb.emitOp(node, 'NEWMAP');
        sb.emitOp(node, 'APPEND');
    }
}

//# sourceMappingURL=AddEmptyModuleHelper.js.map
